<!--柱状图-->
<template>
  <div id="lineChart" :style="style"></div>
</template>
<script>

  export default {
    name: 'echarts-line',
    props: {
      style: {
        type: Object,
        default: {width: '100%', height: '700px'}
      },
      title: {
        type: String,
        default: "历年订单数据分析"
      },
      xData: {//['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        type: Array,
        default: []
      },
      yData: {//[120, 200, 150, 80, 70, 110, 130],
        type: Array,
        default: []
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.drawLine(this.xData, this.yData);
    },
    methods: {
      drawLine(yearList,nowData, beforeData) {
        // 基于准备好的dom，初始化echarts实例
        let lineChart = this.$echarts.init(document.getElementById('lineChart'))
        // 绘制图表
        let option = option = {
          title: {
            text: '历年订单全年数据分析',
            subtext: '数据分析'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: yearList
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar','stack','tiled'] },
              restore: { show: true },
              saveAsImage: { show: true }
            }
          },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              itemStyle: {        //上方显示数值
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: 'gray',
                      fontSize: 16
                    }
                  }
                }
              },
              name: yearList[1],
              type: 'bar',
              data:  nowData,
            },
            {
              itemStyle: {        //上方显示数值
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: { //数值样式
                      color: 'gray',
                      fontSize: 16
                    }
                  }
                }
              },
              name: yearList[0],
              type: 'bar',
              data:  beforeData,
            }
          ]
        };
        lineChart.setOption(option);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/echarts-bend/echarts-bend.vue